import { Component, OnInit } from '@angular/core';
import { AuthenticationService } from '../../_services';

@Component({
  selector: 'app-not-found',
  templateUrl: './not-found.component.html',
  styleUrls: ['./not-found.component.css']
})
export class NotFoundComponent implements OnInit {
  homeLink: string;
  constructor(private authenticationService: AuthenticationService) { }

  ngOnInit() {
    this.homeLink = this.authenticationService.isLoggedIn() ? '/home' : '/landing-page';
  }

}



// WEBPACK FOOTER //
// ./public/app/common/not-found/not-found.component.ts